import type { NavLink, SiteConfig } from '@/types'

import { getOrigin } from '@/lib/window'

export const siteConfig: SiteConfig = {
    name: 'Hundred Step',
    tagline: 'Accounting information systems, made clear',
    description: 'Hundred Step helps organizations implement accounting information systems, strengthen internal control and automate reporting, and shares a free book and accounting learning games.',
    url: getOrigin()
}

export const NAV_LINKS: NavLink[] = [
    { label: 'Home', href: '/' },
    { label: 'Services', href: '/services' },
    { label: 'Book', href: '/book' },
    { label: 'Games', href: '/games' }
]
